/** @format */

import {Button} from '@mui/material';
import {styled} from '@mui/material/styles';

export const StyledButton = styled(Button)(({theme}) => ({
  marginBottom: theme.spacing(3),
  color: '#8B8B8B',
  background: '#202020',
  border: 'none',
  padding: theme.spacing(2.5),
  marginTop: theme.spacing(2),
}));
